import { render, staticRenderFns } from "./third-dialog.vue?vue&type=template&id=d248ea2e&scoped=true"
import script from "./third-dialog.vue?vue&type=script&lang=ts"
export * from "./third-dialog.vue?vue&type=script&lang=ts"
import style0 from "./third-dialog.vue?vue&type=style&index=0&id=d248ea2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d248ea2e",
  null
  
)

export default component.exports